/**
 * Buttons
 */
export enum EAvailabilityType {
  ADD_TO_CART = 'ADD_TO_CART',
  PURCHASE_CD = 'PURCHASE_CD',
  DISCONTINUED = 'DISCONTINUED',
}

export enum EApcButtonType {
  ADD_TO_CART = 'ADD_TO_CART',
  DOWNLOAD_BUTTON = 'DOWNLOAD_BUTTON',
}

export const ADD_TO_CART_EXCEPTION_CODES = {
  MAXIMUM_COUNT_WITH_LINK: 'maximumCartCountWithLinkError',
  MAXIMUM_COUNT: 'maximumCartCountError',
};

export const PLACEHOLDERS = {
  HOST: '#apcHost#',
  COUNTRY: '#countryCode#',
  LANGUAGE: '#languageCode#',
  FAVORITES_LINK: '{favorites-link}',
  PRODUCT_ID: '#productId#',
  SKUS: '#skus#',
  QTY: '#qty#',
  Chat_CSC_ID: '#Chat_CSC_ID#',
};

const QUERY_LOCALES = `languageCode=${PLACEHOLDERS.LANGUAGE}&countryCode=${PLACEHOLDERS.COUNTRY}&Chat_CSC_ID=${PLACEHOLDERS.Chat_CSC_ID}`;
const QUERY_LOCALES_WITHOUT_CHAT = `languageCode=${PLACEHOLDERS.LANGUAGE}&countryCode=${PLACEHOLDERS.COUNTRY}`;
const SKU_LIST = `&SKU_List=${PLACEHOLDERS.SKUS}`;
const QTY_LIST = `&qty_list=${PLACEHOLDERS.QTY}&Chat_CSC_ID=${PLACEHOLDERS.Chat_CSC_ID}`;

export const URLS = {
  ADD_TO_CART: `${PLACEHOLDERS.HOST}/rest/model/atg/commerce/order/purchase/CartModifierActor/addItemToOrder?${QUERY_LOCALES}`,
  GO_TO_CART: `${PLACEHOLDERS.HOST}/shop/${PLACEHOLDERS.COUNTRY}/${PLACEHOLDERS.LANGUAGE}/cart/shoppingCart.jsp`,
  PRODUCT_AVAILABILITY: `${PLACEHOLDERS.HOST}/rest/model/schneider/catalog/availability/rest/ProductAvailabilityActor/pdpProductAvailabilityInfo?partNumbersList=${PLACEHOLDERS.PRODUCT_ID}&${QUERY_LOCALES}`,
  ADD_TO_FAVORITES: `${PLACEHOLDERS.HOST}/rest/model/atg/commerce/order/purchase/CartModifierActor/addItemToFavorites?${QUERY_LOCALES}`,
  REMOVE_FROM_FAVORITES: `${PLACEHOLDERS.HOST}/rest/model/atg/commerce/order/purchase/CartModifierActor/removeItemFromFavorites?${QUERY_LOCALES}`,
  MY_LIST: `${PLACEHOLDERS.HOST}/shop/${PLACEHOLDERS.COUNTRY}/${PLACEHOLDERS.LANGUAGE}/myaccount/myAccountMyList.jsp`,
  CREATE_ACCOUNT: `${PLACEHOLDERS.HOST}/shop/${PLACEHOLDERS.COUNTRY}/${PLACEHOLDERS.LANGUAGE}/pdp/authBeforeAddingToMyFavorites.jsp?skuId=SKU-${PLACEHOLDERS.PRODUCT_ID}&productId=P-${PLACEHOLDERS.PRODUCT_ID}&type=reg`,
  SIGN_IN: `${PLACEHOLDERS.HOST}/shop/${PLACEHOLDERS.COUNTRY}/${PLACEHOLDERS.LANGUAGE}/pdp/authBeforeAddingToMyFavorites.jsp?skuId=SKU-${PLACEHOLDERS.PRODUCT_ID}&productId=P-${PLACEHOLDERS.PRODUCT_ID}`,
  ADD_TO_CART_SUCCESS: `/rest/model/atg/commerce/order/purchase/CartModifierActor/addItemToOrderSuccess?${QUERY_LOCALES}`,
  ADD_TO_CART_ERROR: `/rest/model/atg/commerce/order/purchase/CartModifierActor/addItemToOrderError?${QUERY_LOCALES}`,
  COMPARISON_ADD_TO_CART: `${PLACEHOLDERS.HOST}/rest/model/atg/commerce/order/purchase/CartModifierActor/addItemsToOrder?${QUERY_LOCALES_WITHOUT_CHAT}${SKU_LIST}${QTY_LIST}`,
};

export const enum ECtaButtonTypes {
  BUY_ONLINE_BUTTON_REGULAR = 'BUY_ONLINE_BUTTON_REGULAR',
  BUY_ONLINE_BUTTON_APC = 'BUY_ONLINE_BUTTON_APC',
  DOWNLOAD_BUTTON = 'DOWNLOAD_BUTTON',
  NOTIFY_ME_BUTTON = 'NOTIFY_ME_BUTTON',
  ADD_TO_CART_BUTTON = 'ADD_TO_CART_BUTTON',
  PROMOTED_BUTTON = 'PROMOTED_BUTTON',
  PRODUCT_SELECTOR_BUTTON = 'PRODUCT_SELECTOR_BUTTON',
}

export const PRIMARY_BUTTONS = [
  // order matters
  ECtaButtonTypes.NOTIFY_ME_BUTTON,
  ECtaButtonTypes.DOWNLOAD_BUTTON,
  ECtaButtonTypes.PRODUCT_SELECTOR_BUTTON,
  ECtaButtonTypes.BUY_ONLINE_BUTTON_REGULAR,
  ECtaButtonTypes.BUY_ONLINE_BUTTON_APC,
];

export const SECONDARY_BUTTONS = [ ECtaButtonTypes.ADD_TO_CART_BUTTON ];

export const APC_PRIMARY_BUTTONS = [
  // order matters
  ECtaButtonTypes.NOTIFY_ME_BUTTON,
  ECtaButtonTypes.DOWNLOAD_BUTTON,
  ECtaButtonTypes.PRODUCT_SELECTOR_BUTTON,
  ECtaButtonTypes.BUY_ONLINE_BUTTON_REGULAR,
];

export const DEFAULT_CTA_DROPDOWN_LABEL = 'More Options';

// Product CTA's
export const productCtasColors = {
  PRIMARY_BLUE: 'primaryBlue',
  SECONDARY_BLUE: 'secondaryBlue',
  PRIMARY_GREEN: 'primaryGreen',
  SECONDARY_GREEN: 'secondaryGreen',
} as const;

export const MAX_CTA_LIMIT = 3;

export const ADDITIONAL_CTA_LINKS = 'addition-links';

export const NUMBER_OF_BUTTONS_BEFORE = 3;

export const productCtasButtonType = {
  CART: 'cart',
  FAVORITES: 'favorites',
  COMPARE: 'compare',
} as const;

export const productCtas = {
  buttons: {
    [productCtasButtonType.CART]: {
      isShown: true,
      list: [],
      color: productCtasColors.PRIMARY_BLUE,
      icons: {
        addIcon: 'shopping-cart',
        disableIconInPdpCtaBlock: true,
      },
      dataset: {
        daElementId: 'add_p',
      },
      labels: {},
    },
    [productCtasButtonType.FAVORITES]: {
      isShown: false,
      list: [],
      color: productCtasColors.SECONDARY_BLUE,
      icons: {
        addIcon: 'star',
        removeIcon: 'star-filled',
      },
      dataset: {
        daElementId: 'add_p',
      },
      labels: {},
    },
  },
  productProp: 'repositoryId',
};

// Icons
export const pesIconMirrorDirection = {
  HORIZONTAL: 'horizontal',
  VERTICAL: 'vertical',
  BOTH: 'both',
} as const;

export const LOAD_TIMEOUT = 10000;
export const ICON_FONT_NAME = 'se-icon';

export const MAX_LINE_LIMIT = {
  desktop: 5,
  mobile: 4,
};
export const MAX_IMG_LIMIT = 3;

export const DEFAULT_LINE_HEIGHT = '24px';

export const pesIconSizes = {
  NANO: 'nano',
  MICRO: 'micro',
  SMALL: 'small',
  MEDIUM: 'medium',
  LARGE: 'large',
  XLARGE: 'xlarge',
} as const;

export const ONLINE_SOFTWARE = 'Online Software';
export const PDP_SOFTWARE = 'Software';
export const ONLINE_CONFIGURATOR = 'Online Configurator';
export const CONFIGURATOR = 'Configurator';

export const CTA_TYPES = {
  ONLINE_SOFTWARE,
  PDP_SOFTWARE,
  ONLINE_CONFIGURATOR,
  CONFIGURATOR,
  BUY_ONLINE: 'buy-online',
  REQUEST_DEMO: 'request-demo',
  SOFTWARE_FREE_TRIAL: 'software-free-trial',
  ASK_THE_COMMUNITY: 'ask-the-community',
  TALK_TO_AN_EXPERT: 'talk-to-an-expert',
};

export const ONLINE_CTA_TYPES = {
  [ONLINE_SOFTWARE]: true,
  [ONLINE_CONFIGURATOR]: true,
  [CTA_TYPES.BUY_ONLINE]: true,
  [CTA_TYPES.REQUEST_DEMO]: true,
  [CTA_TYPES.SOFTWARE_FREE_TRIAL]: true,
  [CTA_TYPES.ASK_THE_COMMUNITY]: true,
  [CTA_TYPES.TALK_TO_AN_EXPERT]: true,
};

export enum RangeCTAPosition {
  EMPHASIZED = 'Primary-button',
  STANDARD = 'Secondary-button',
  SUBDUED = 'Subdued-button',
  OPTIONS = 'Options',
}
